export default __webpack_public_path__ + "static/media/img_login.1a712179.png";